import React from "react";
import { leftIcon, rightIcon } from "../../../assets";

const PaginationComponent = ({ pageIndex, pageCount, onPageChange }) => {
  const handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage <= pageCount) {
      console.log(newPage);
      onPageChange(newPage);
    }
  };

  return (
    <>
    {pageCount > 0 ? <div className="flex items-center justify-between mt-4">
      <button
        onClick={() => handlePageChange(1)}
        disabled={pageIndex === 1}
        className="px-5 py-2 font-bold bg-gray-200 rounded-lg disabled:opacity-50 hover:bg-gray-300"
      >
        {"<<"}
      </button>
      <button
        onClick={() => handlePageChange(pageIndex - 1)}
        disabled={pageIndex === 1}
        className="px-5 py-2 font-bold bg-gray-200 rounded-lg disabled:opacity-50 hover:bg-gray-300 mx-2"
      >
        {"<"}
      </button>
      <span className="text-md font-bold">
        {`${pageCount ? pageIndex : 0} - ${pageCount}`}
      </span>
      <button
        onClick={() => handlePageChange(pageIndex + 1)}
        disabled={pageIndex >= pageCount}
        className="px-5 py-2 font-bold bg-gray-200 rounded-lg disabled:opacity-50 hover:bg-gray-300 mx-2"
      >
        {">"}
      </button>
      <button
        onClick={() => handlePageChange(pageCount)}
        disabled={pageIndex >= pageCount}
        className="px-5 py-2 font-bold bg-gray-200 rounded-lg disabled:opacity-50 hover:bg-gray-300"
      >
        {">>"}
      </button>
    </div> : null}
    </>
  );
};

export default PaginationComponent;
